'use client';

import { AdZoneDisplay } from '@/components/ads/AdZoneDisplay';

interface AdZoneProps {
  zone: string;
  className?: string;
}

const AdZone = ({ zone, className = '' }: AdZoneProps) => {
  return (
    <AdZoneDisplay 
      zone={zone}
      className={className}
      currentPage="marketplace-listings"
      rotationInterval={30000}
      maxAds={3}
    />
  );
};

export default AdZone;